import React, { PropTypes, PureComponent } from 'react';
import selectn from 'selectn';
import { Api } from 'enums';
import { queryString } from 'lib/format';
import canUseDOM from 'lib/util/canUseDOM'
;import injectIntl, { intlShape } from 'common/injectIntl';
import styles from './style';

const { Page: { EVENT_QUERY_KEYS } } = Api;

class PlayerOverlay extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            providerHovered: false,
            signoutWidth: undefined
        };
        this.onLogoutClick = this.onLogoutClick.bind(this);
        this.onProviderMouseOver = this.onProviderMouseOver.bind(this);
        this.onProviderMouseOut = this.onProviderMouseOut.bind(this);
    }

    componentDidMount() {
        this.setSignoutWidth();
    }

    componentDidUpdate() {
        this.setSignoutWidth();
    }

    onLogoutClick(event) {
        event.preventDefault();
        this.props.handleLogout();
    }

    onProviderMouseOver() {
        this.setState({ providerHovered: true });
    }

    onProviderMouseOut() {
        this.setState({ providerHovered: false });
    }

    setSignoutWidth() {
        if (this.signout && this.state.signoutWidth === undefined) {
            this.setState({ signoutWidth: this.signout.offsetWidth + 30 });
        }
    }

    render() {
        const { providerHovered, signoutWidth } = this.state;
        const {
            show,
            name,
            source: {
                name: sourceName,
                logoUrl: sourceLogoUrl
            },
            branding: {
                name: brandingName,
                logoUrl: brandingLogoUrl
            },
            provider,
            location: { query },
            messages,
            intl: { formatMessage }
        } = this.props;

        const newQuery = { ...query };
        Object.keys(newQuery).forEach(key => {
            if (EVENT_QUERY_KEYS.indexOf(key) === -1) {
                delete newQuery[key];
            }
            if (key === 'id' && (newQuery.network || newQuery.channel)) {
                delete newQuery[key];
            }
        });
        const search = queryString(newQuery);
        let watchLink = `/watch/player${search}`;
        if (canUseDOM) { // force http
            watchLink = `http://${window.location.host}${watchLink}`;
        }


        const style = {
            ...styles.header,
            ...styles[show ? 'show' : 'hide']
        };

        const titleStyle = sourceLogoUrl ? styles.title : {
            ...styles.title,
            marginLeft: 10
        };

        const { name: providerName } = provider;
        const providerLogoUrl = selectn('images.colorWithNegativeBackground.href', provider) ||
            selectn('images.logo.href', provider) || '';
        const providerLink = selectn('links.web.href', provider) || '/watch';

        let signoutStyle = {
            ...styles.signout,
            display: 'none'
        };
        if (signoutWidth === undefined) {
            signoutStyle = {
                ...styles.signout,
                width: 'auto',
                visibility: 'hidden'
            };
        } else if (providerHovered) {
            signoutStyle = {
                ...styles.signout,
                width: signoutWidth - 5
            };
        }

        return (
            <div className="player-header" style={style}>
                {sourceLogoUrl && (
                    <div style={styles.logo}>
                        <span style={styles.helper} />
                        <img src={sourceLogoUrl} alt={sourceName} style={styles.logoImg} />
                    </div>
                )}
                {providerLogoUrl ? (
                    <div
                        style={providerHovered ? {
                            ...styles.provider,
                            width: styles.provider.width + signoutWidth
                        } : styles.provider}
                        onMouseOver={this.onProviderMouseOver}
                        onMouseOut={this.onProviderMouseOut}
                    >
                        <span style={styles.helper} />
                        <a
                            href={providerLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            alt={providerName}
                        >
                            <img
                                src={providerLogoUrl}
                                alt={providerName}
                                style={providerHovered ? {
                                    ...styles.logoImg,
                                    maxWidth: `calc(100% - ${signoutWidth}px)`
                                } : styles.logoImg}
                            />
                        </a>
                        <span
                            style={providerHovered ? styles.separator : {
                                ...styles.separator,
                                display: 'none'
                            }}
                        >&nbsp;|&nbsp;</span>
                        <a
                            ref={el => { this.signout = el; }}
                            style={signoutStyle}
                            onClick={this.onLogoutClick}
                        >{formatMessage(messages['signout.label'])}</a>
                    </div>
                ) : (
                    <div
                        style={{ ...styles.provider, marginTop: 10 }}
                    >
                        <span
                            style={styles.separator}
                        >&nbsp;|&nbsp;</span>
                        <a
                            ref={el => { this.signout = el; }}
                            style={{
                                ...styles.signout,
                                width: signoutWidth - 5
                            }}
                            onClick={this.onLogoutClick}
                        >{formatMessage(messages['signout.label'])}</a>
                    </div>
                )}
                <div style={styles.branding}>
                    <span style={styles.helper} />
                    <a
                        href={watchLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={formatMessage(messages['syndicated.player.branding.tooltip'], {
                            brandingName
                        })}
                    >
                        <img src={brandingLogoUrl} alt={brandingName} style={styles.logoImg} />
                    </a>
                </div>
                <div style={titleStyle} title={name}>
                    <span style={styles.helper} />
                    <span style={styles.titleText}>{name}</span>
                </div>
            </div>
        );
    }
}

PlayerOverlay.defaultProps = {
    show: false,
    source: {},
    branding: {},
    provider: {}
};

PlayerOverlay.propTypes = {
    show: PropTypes.bool,
    name: PropTypes.string,
    source: PropTypes.object,
    branding: PropTypes.object,
    provider: PropTypes.object,
    location: PropTypes.object,
    handleLogout: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    messages: PropTypes.object.isRequired
};

export default injectIntl(PlayerOverlay);



// WEBPACK FOOTER //
// ./app/webapp/syndicated/PlayerOverlay/index.js